// 日付・時刻のヘルパー（外部ライブラリ不要）

const pad = (n) => String(n).padStart(2, '0');

const WEEKDAYS = ['日', '月', '火', '水', '木', '金', '土'];

// Date -> "YYYY-MM-DD"
export const toDateStr = (d) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// "YYYY-MM-DD" -> その日の 00:00 の Date
export const dateStrToMidnight = (s) => {
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d, 0, 0, 0, 0);
};

// "YYYY-MM-DD" -> "日"
export const weekdayOf = (dateStr) => WEEKDAYS[dateStrToMidnight(dateStr).getDay()];

// "YYYY-MM-DD" -> "2026/08/09 (日)"
export const formatDateLabel = (dateStr) =>
  `${dateStr.replace(/-/g, '/')} (${weekdayOf(dateStr)})`;

// Date -> "HH:mm"
export const fmtHM = (d) => `${pad(d.getHours())}:${pad(d.getMinutes())}`;

// 現在時刻 "HH:mm"
export const nowHM = (d = new Date()) => fmtHM(d);

// Date に分を足した Date
export const addMinutesToDate = (d, minutes) =>
  new Date(d.getTime() + minutes * 60000);

// 分数 -> "H:MM"（マイナスは "-H:MM"）
export const minutesToHM = (mins) => {
  const neg = mins < 0;
  const total = Math.floor(Math.abs(mins));
  return `${neg ? '-' : ''}${Math.floor(total / 60)}:${pad(total % 60)}`;
};

// 秒 -> "MM:SS"（1時間以上なら "H:MM:SS"）
export const secToClock = (sec) => {
  const total = Math.abs(Math.floor(sec));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
};

// ISO文字列2つから経過分（四捨五入）
export const diffMinutes = (startIso, endIso) => {
  if (!startIso || !endIso) return 0;
  return Math.max(
    0,
    Math.round((new Date(endIso).getTime() - new Date(startIso).getTime()) / 60000)
  );
};

// ISO文字列2つから経過秒（切り捨て）
export const diffSeconds = (startIso, endIso) => {
  if (!startIso || !endIso) return 0;
  return Math.max(
    0,
    Math.floor((new Date(endIso).getTime() - new Date(startIso).getTime()) / 1000)
  );
};

// ISO文字列 -> "HH:mm"
export const isoToHM = (iso) => (iso ? fmtHM(new Date(iso)) : '--:--');

// 見積の表示用（null は空文字）
export const estToText = (v) => (v === null || v === undefined ? '' : String(v));

/**
 * 見積(分) -> "HH:MM"。未入力は "--:--"
 *   80 -> "01:20" / 5 -> "00:05" / 120 -> "02:00"
 */
export const minutesToEst = (v) => {
  if (v === null || v === undefined) return '--:--';
  const total = Math.max(0, Math.floor(v));
  return `${pad(Math.floor(total / 60))}:${pad(total % 60)}`;
};

/**
 * 見積(分) -> 入力欄に出す4桁。未入力は空文字
 *   80 -> "0120"
 */
export const minutesToEstDigits = (v) => {
  if (v === null || v === undefined) return '';
  const total = Math.max(0, Math.floor(v));
  return `${pad(Math.floor(total / 60))}${pad(total % 60)}`;
};

/**
 * 入力された数字を見積(分)にする。
 *   1〜3桁 … そのまま分（5→5 / 80→80 / 120→120）
 *   4桁    … 時分（0120→80 / 0230→150）。後ろ2桁が60以上は無効
 *   空     … null（未入力）
 *   それ以外・5桁以上 … undefined（無効。呼び出し側で元の値に戻す）
 */
export const estInputToMinutes = (raw) => {
  const s = String(raw ?? '').replace(/[^0-9]/g, '');
  if (s === '') return null;
  if (s.length <= 3) return parseInt(s, 10);
  if (s.length === 4) {
    const h = parseInt(s.slice(0, 2), 10);
    const m = parseInt(s.slice(2), 10);
    if (m > 59) return undefined;
    return h * 60 + m;
  }
  return undefined;
};

// 見積の数値化（null は 0 として計算）
export const estToNum = (v) => (v === null || v === undefined ? 0 : v);

/**
 * 実行中タスクの「まだかかる時間」を分で返す。
 *   残り秒 = 見積(分) × 60 − 経過秒
 *   秒は切り上げて分にする。0未満は 0。
 */
export const remainingMinutesOf = (task, now = Date.now()) => {
  if (task.estimatedMinutes === null || task.estimatedMinutes === undefined) return 0;
  if (!task.startedAt) return 0;
  const elapsedSec = (now - new Date(task.startedAt).getTime()) / 1000;
  const remainingSec = task.estimatedMinutes * 60 - elapsedSec;
  if (remainingSec <= 0) return 0;
  return Math.ceil(remainingSec / 60);
};
